import { render, staticRenderFns } from "./RecipeTags.vue?vue&type=template&id=5a5fa6da&scoped=true"
import script from "./RecipeTags.vue?vue&type=script&lang=js"
export * from "./RecipeTags.vue?vue&type=script&lang=js"
import style0 from "./RecipeTags.vue?vue&type=style&index=0&id=5a5fa6da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5fa6da",
  null
  
)

export default component.exports